import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-8">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              按风格找电影
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              无论你想重温一场经典，还是寻找一份轻松，这里都有属于你的故事
            </p>
          </div>
          <Link
            to="/category"
            className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {movieCategories.map((c) => (
            <Link
              key={c.id}
              to={`/category?genre=${encodeURIComponent(c.genre)}`}
              className="group flex flex-col items-center text-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <span className="font-heading font-semibold text-sm text-foreground-950">
                {c.name}
              </span>
              <span className="mt-1 text-xs text-foreground-500 leading-snug">
                {c.desc}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}